import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin", { replace: true });
      return;
    }
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => navigate("/admin", { replace: true, state: { user: res.data } }))
      .catch(() => navigate("/admin", { replace: true }));
  }, [location.hash, navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-[#1C201D] flex items-center justify-center">
      <p className="font-display text-2xl italic text-[#FAF7F2]">Preparing your dashboard…</p>
    </div>
  );
}
